'use client';
import { FC } from 'react';
import styles from './OrganizationHeroSection.module.scss';
import SearchConsole from '../SearchConsole';
import OrganizationInfoBlock from '../OrganizationInfoBlock';

import { EventArrElement } from '@/models/EventModels';
import Image from 'next/image';
import { OrganizationInfo } from '@/models/OrganizationModels';

interface OrganizationHeroSectionProps {
  className?: string;
  events: EventArrElement[];
  statistic: OrganizationInfo;
}

const OrganizationHeroSection: FC<OrganizationHeroSectionProps> = ({
  className = '',
  events,
  statistic,
}) => {
  // const background__image = events.length > 0 ? events[2].poster_image : '';
  return (
    <section className={`${styles.root} ${className}`}>
      {/*<Image*/}
      {/*  className={styles.background}*/}
      {/*  src={background__image || ''}*/}
      {/*  alt="background__image"*/}
      {/*  width={'1600'}*/}
      {/*  height={'900'}*/}
      {/*/>*/}
      <div className={`${styles.container} container`}>
        {/*<SearchConsole />*/}
        <OrganizationInfoBlock statistic={statistic} />
      </div>
    </section>
  );
};

export default OrganizationHeroSection;
